"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const koLocaleData = require("i18next-icu/locale-data/ko");
exports.default = koLocaleData;
//# sourceMappingURL=ko.js.map